<template>
  <div
    class="w-full flex flex-wrap items-center gap-2 bg-white border border-untitled-gray-200 rounded-lg p-3"
  >
    <div class="w-full sm:w-80 flex">
      <ElInput
        size="large"
        :prefix-icon="SearchIcon"
        placeholder="Search"
        @keyup.enter="handleOnSearch"
        v-model="search"
      />
    </div>
    <div v-if="false">
      <CourseFilters
        v-model="selectedFilter"
        @applyFilters="handleApplyFilters"
        :hideSortProgress="hideSortProgress"
        :hideEnrolledProgress="hideEnrolledProgress"
        :hideAvailableCourse="hideAvailableCourse"
        :show-high-low-progress="showHighLowProgress"
        @clearFilters="handleClearFilters"
      />
    </div>
    <ElButton v-if="false" @click="handleClickReset" :icon="RefreshIcon" size="large">
      Reset
    </ElButton>
  </div>
</template>

<script setup>
import { ElButton, ElInput } from "element-plus";
import { SearchIcon } from "@heroicons/vue/solid";
/*Temporarily hide category filter to enhance load page of home page*/
/*import DropdownMenu from "@/components/element-components/DropdownMenu.vue";*/
import CourseFilters from "@/components/home/filters/CourseFilters.vue";
import { useEnrolledCourseStore } from "@/stores/enrolledCourseStore";
import { storeToRefs } from "pinia";
import { RefreshIcon } from "@heroicons/vue/solid";
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import { defineProps, onUnmounted } from "vue";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { ref } from "vue";

const props = defineProps({
  hideSortProgress: {
    type: Boolean,
    default: false,
  },
  hideEnrolledProgress: {
    type: Boolean,
    default: false,
  },
  hideAvailableCourse: {
    type: Boolean,
    default: false,
  },
  courseFilters: {
    type: Boolean,
  },
  showHighLowProgress: {
    type: Boolean,
    default: true,
  },
});

const router = useRouter();
const enrolledCourseStore = useEnrolledCourseStore();
const homeEnrolledCoursesStore = useHomeCoursesStore();

const { selectedFilter } = storeToRefs(enrolledCourseStore);

const hideSortProgress = computed(() => props.hideSortProgress);
const hideEnrolledProgress = computed(() => props.hideEnrolledProgress);
const hideAvailableCourse = computed(() => props.hideAvailableCourse);
const courseFilters = computed(() => props.courseFilters);
const showHighLowProgress = computed(() => props.showHighLowProgress);

const search = ref("");

const handleClickReset = () => {
  enrolledCourseStore.handleReset();
  homeEnrolledCoursesStore.handleFetchCourses();
};

const handleApplyFilters = () => {
  if (
    (selectedFilter.value.available_course ||
      selectedFilter.value.enrolled_course ||
      selectedFilter.value.course_category ||
      selectedFilter.value.course_category.length) &&
    courseFilters.value
  ) {
    homeEnrolledCoursesStore.resetPagination()
    homeEnrolledCoursesStore.handleFetchCourses();

  }
};

const handleOnSearch = () => {
  router.push({
    name: "search",
    query: {
      search: search.value,
    },
  });
};

const handleClearFilters = () => {
  enrolledCourseStore.handleReset();
};

onUnmounted(() => {
  search.value = "";
});
</script>

<style scoped></style>
